var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMediumWhite = function SvgMediumWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 200H0V0H200V200ZM166.417 152.925V150.683L156.025 140.483C155.108 139.783 154.65 138.633 154.842 137.492V62.5083C154.65 61.3667 155.108 60.2167 156.025 59.5167L166.667 49.3167V47.075H129.817L103.55 112.6L73.6667 47.075H35.0167V49.3167L47.4667 64.3083C48.6833 65.4167 49.3083 67.0333 49.1417 68.6667V127.6C49.5083 129.725 48.8333 131.9 47.3417 133.45L33.3333 150.433V152.675H73.05V150.433L59.0417 133.45C57.5333 131.9 56.825 129.742 57.1083 127.6V76.6333L91.9667 152.675H96.0167L125.958 76.6333V137.242C125.958 138.858 125.958 139.175 124.9 140.233L114.133 150.683V152.925H166.417Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMediumWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium_white.292f26a3.svg";
export { ForwardRef as ReactComponent };